export default class SimulationTargetSelector {
  static getSimulationTargets = state =>
    state.simulationTargets.entities.simulationTargets;
}
